import type { IDropdownOption } from "@fluentui/react";

const lang = JSON.parse(localStorage.getItem("userLanguagePreferences"));

export const FILE_ALL_KEY = "All";
export const FILE_ALL_LABEL = lang === "fr" ? "Toutes" : "All";
export const FILE_SEARCH_PLACEHOLDER = lang === "fr" ? "Rechercher un fichier..." : "Search filename...";

export function withAllFilesFirst(fileOptions: string[]): IDropdownOption[] {
    const rest = (fileOptions ?? [])
        .filter(file => file !== FILE_ALL_KEY)
        .sort((a, b) => a.localeCompare(b))
        .map(file => ({
            key: file,
            text: file
        }));

    return [{ key: FILE_ALL_KEY, text: FILE_ALL_LABEL }, ...rest];
}